<div class="ui-g ui-fluid">
  <div class="ui-g-12" class="background">
    <div class="ui-g-12">
      <h2 class="title">Emergencias</h2>
    </div>
  </div>
  <div class="ui-g-12">
    <div class="ui-g-1 ui-md-1 ui-lg-1"></div>
    <div class=" ui-g-12 ui-md-12 ui-lg-10">
      <div class="ui-g-12 ui-md-4 ui-lg-3">
        <div class="center">
          <img src="../../assets/images/important-phones/telefono.png" alt="" style="margin: 20% auto; width: 250px;">
        </div>
      </div>
      <div class="ui-g-12 ui-md-8 ui-lg-9" style="margin-top: 50px;">
        <div class="ui-g-12 ui-md-6 ui-lg-6" *ngFor="let emergencyPhone of emergencyPhones; let i = index">
          <div class="cardBlue ui-g-12">
            <div class="center">
              <img class="margin" src="../../assets/images/emergency/Tecniseguros.png" alt="">
            </div>
            <div class="fondo">
              <h3>{{emergencyPhone.title}}</h3>
              <h2 class="subTitle">{{emergencyPhone.desc}}</h2>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="ui-g-12 ui-md-8 ui-lg-9">
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          <div class="cardBlue3 ui-g-12">
            <div class="center">
              <img class="margin" src="../../assets/images/emergency/Asistencia Aseguradora.png" alt="" >
            </div>
            <div class="fondo">
              <h3>Tecniseguros Assist</h3>
              <h2 class="subTitle">(502) 2383 6970</h2>
            </div>
          </div>
        </div>
      <div class="ui-g-1 ui-md-1 ui-lg-1"></div>
    </div>-->
  
</div>
